import { ProductColor } from '../../../../integrations/relewise/types/mapped';
import { AddToCartSelection } from '../add-to-cart-drawer.types';

interface GetActiveSelectionArgs {
    selection: AddToCartSelection;
    masterProductRecordId: number | undefined;
    preferredColorName: string | undefined;
    allColors: ProductColor[] | undefined;
    compatibleSizesByColor: Record<string, string[]> | undefined;
}

export const getActiveSelection = ({
    selection,
    masterProductRecordId,
    preferredColorName,
    allColors,
    compatibleSizesByColor
}: GetActiveSelectionArgs) => {
    const userSelection = selection.productRecordId === masterProductRecordId ? selection : undefined;
    const activeColor = userSelection?.color ?? allColors?.find(c => c.name === preferredColorName) ?? allColors?.[0];
    const sizesForActiveColor = activeColor ? (compatibleSizesByColor?.[activeColor.name] ?? []) : [];
    const activeSize = userSelection?.size ?? (sizesForActiveColor.length === 1 ? sizesForActiveColor[0] : undefined);
    const showSizeRequiredError = !!userSelection?.sizeRequiredError && !activeSize;

    return { activeColor, activeSize, sizesForActiveColor, showSizeRequiredError };
};
